import {useEffect, useMemo} from 'react';

import type {FilterObject} from 'nutshell-core/types';

import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import {analyticsClient} from '../../../analytics-client';

import {MeetingReport} from '../../scheduler/report/meeting-report';
import {SchedulerFeatureGatePage} from '../../scheduler/report/scheduler-feature-gate-page';

import type {LeadsReportKey} from '../report-types';

import {EmptyStateNoMeeting} from './empty-state-no-meeting';
import {getFiltersFromUrl} from './helpers';
import {MeetingSelector} from './meeting-selector';

import styles from '../activity/activity-report.module.css';

interface Props {
    activeFilters: FilterObject[];
    urlParams: any;
    reportKey: LeadsReportKey;
    onParamChange: (arg1: any, arg2: boolean) => any;
}

export function SchedulerReport(props: Props) {
    const {onParamChange} = props;

    const {meetingId} = getFiltersFromUrl(props.activeFilters);

    const currentFilter = useMemo(() => props.urlParams.filter || {}, [props.urlParams.filter]);

    const handleMeetingChange = (newMeetingOption: TwoLineOptionWithIcon | null) => {
        const newMeetingId = newMeetingOption ? newMeetingOption.value : null;
        const newFilter = {...currentFilter, meetingId: newMeetingId};

        onParamChange({filter: newFilter}, true);
    };

    useEffect(() => {
        if (analyticsClient) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_REPORT_SCHEDULER_VIEW);
        }
    }, []);

    return (
        <div id='report-content-scroll-container' className={styles.container}>
            {!NutClientConfig.canUseScheduler ? (
                <SchedulerFeatureGatePage />
            ) : (
                <div className='px-16'>
                    <MeetingSelector
                        handleMeetingChange={handleMeetingChange}
                        meetingId={meetingId}
                    />
                    {meetingId ? (
                        <MeetingReport meetingId={meetingId} hideHeader={true} />
                    ) : (
                        <EmptyStateNoMeeting />
                    )}
                </div>
            )}
        </div>
    );
}
